// extracted by mini-css-extract-plugin
export var PageBanner = "bikerTitle-module--PageBanner--2gSFw";
export var Triangle = "bikerTitle-module--Triangle--hr4ns";
export var ShapeFill = "bikerTitle-module--ShapeFill--bSn8o";